import React from 'react';
import PropTypes from 'prop-types';

import PivotTableComponent  from '../../../components/Inspect/PivotTableComponent';
import { Button, Chip, Box } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';
import BarChartIcon from '@mui/icons-material/BarChart';

const pivotTableDefaults = [
   {
      name: 'Material Heatmap',
      icon: 'table',
      state: {
         rendererName: 'Table Heatmap',
         rows: ['Material'],
         cols: ['PlacementYear'],
      },
   },
   {
      name: 'Diameter Heatmap',
      icon: 'table',
      state: {
         rendererName: 'Table Heatmap',
         rows: ['DiameterInch'],
         cols: ['PlacementYear'],
      },
   },
   {
      name: 'Combined Heatmap',
      icon: 'table',
      state: {
         rendererName: 'Table Heatmap',
         rows: ['Material', 'DiameterInch'],
         cols: ['PlacementYear'],
      },
   },
   {
      name: 'Material Chart',
      icon: 'chart',
      state: {
         rendererName: 'Stacked Column Chart',
         rows: ['Material'],
         cols: ['PlacementYear'],
      },
   },
   {
      name: 'Diameter Chart',
      icon: 'chart',
      state: {
         rendererName: 'Stacked Column Chart',
         rows: ['DiameterInch'],
         cols: ['PlacementYear'],
      },
   },
   {
      name: 'Combined Chart',
      icon: 'chart',
      state: {
         rendererName: 'Stacked Column Chart',
         rows: ['Material', 'DiameterInch'],
         cols: ['PlacementYear'],
      },
   }
];

export default class PivotTableTab extends React.Component {

   constructor(props) {
      super(props);

      this.renderDefaultsButtons = this.renderDefaultsButtons.bind(this);

      this.state = {
         pivotState: {
            rendererName: 'Table Heatmap',
            rows: ['Material'],
            cols: ['PlacementYear'],
         }
      };
   }

   renderDefaultsButtons() {
      const containerStyle = {
         display: 'flex',
         flexWrap: 'wrap',
         gap: '8px',
         padding: '12px 16px',
         backgroundColor: '#ffffff',
         borderRadius: '8px',
         marginBottom: '16px',
         border: '1px solid #e8f4f8',
      };

      const titleStyle = {
         color: '#2c3e50',
         fontSize: '1.2rem',
         fontWeight: 600,
         marginRight: '16px',
         display: 'flex',
         alignItems: 'center',
      };

      return (
         <Box style={containerStyle}>
            <span style={titleStyle}>Presets:</span>
            {
               pivotTableDefaults.map((item, index) => {
                  return (
                     <Chip
                        key={index}
                        icon={item.icon === 'table' ? <TableChartIcon /> : <BarChartIcon />}
                        label={item.name}
                        onClick={() => {
                           const pivotState = Object.assign({}, this.state, {
                              pivotState: Object.assign({}, this.state.pivotState, item.state)
                           });
                           this.setState(pivotState);
                        }}
                        sx={{
                           backgroundColor: '#e8f4f8',
                           color: '#2c3e50',
                           fontWeight: 500,
                           fontSize: '0.95rem',
                           padding: '4px 8px',
                           '&:hover': {
                              backgroundColor: '#75cae3',
                              color: '#ffffff',
                           },
                           '& .MuiChip-icon': {
                              color: '#1487ae',
                           },
                           '&:hover .MuiChip-icon': {
                              color: '#ffffff',
                           },
                        }}
                     />
                  );
               })
            }
         </Box>
      );
   }

   render() {
      const containerStyle = {
         padding: '8px',
      };

      const pivotCardStyle = {
         backgroundColor: '#ffffff',
         borderRadius: '8px',
         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
         border: '1px solid #e8f4f8',
         padding: '16px',
         overflow: 'auto',
      };

      return (
         <div style={containerStyle}>
            {this.renderDefaultsButtons()}

            <div style={pivotCardStyle}>
               <PivotTableComponent
                  sortedAlertsDataSet={this.props.sortedAlertsDataSet}
                  selectAlertsByFilters={this.props.selectAlertsByFilters}
                  pivotState={this.state.pivotState}
               />
            </div>
         </div>
      );
   }
}
